export const findLabel = (
  list: any[],
  id: number,
  key: string = "name",
  lang: string = "en"
) => {
  const item = list?.find((item) => item.id === id);
  if (!item) return "-";

  const value = item[key];

  // kalau multilingual object
  if (typeof value === "object" && value !== null) {
    return value[lang] ?? value["id"] ?? "-";
  }

  // kalau string biasa
  return value ?? "-";
};
